









































































import { Vue, Component } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { ShoppingCartItem, ShoppingCart } from "@/types";
import SharedMixin from "@/mixins/shared";

@Component({
  metaInfo: {
    title: "Sepetim"
  },
  mixins: [SharedMixin]
})
export default class ShoppingCartIndex extends Vue {
  cart = {} as ShoppingCart;
  cartItemCount = 0;

  async removeItemFromCart(item: ShoppingCartItem) {
    await this.$store.dispatch("ecommerce/removeItemFromCart", item);
    this.cartItemCount = this.$store.getters["ecommerce/cartItemCount"];
  }

  buy() {
    this.$router.push({ name: "shopping-cart-payment" });
  }

  mounted() {
    this.$emit("setStep", 1);

    this.cart = this.$store.getters["ecommerce/shoppingCart"];
    this.cartItemCount = this.$store.getters["ecommerce/cartItemCount"];
  }
}
